'use client';

import type { ReactNode } from 'react';
import { AuthContextProvider } from '../AuthContext';
import type { AuthProviderProps } from '../types';
import { useElectronAuth } from '../../../../hooks/useElectronOpenIdAuth';

const LocalAuthContextBridge = ({ children }: { children: ReactNode }) => {
  const { contextValue } = useElectronAuth({ providerType: 'local' });

  return (
    <AuthContextProvider value={contextValue}>{children}</AuthContextProvider>
  );
};

export const LocalAuthProvider = ({ children }: AuthProviderProps) => {
  return <LocalAuthContextBridge>{children}</LocalAuthContextBridge>;
};
